import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
  AccountSchema,
  mcpExposeMetadata,
  OKGeneric,
  PostAccountSchema,
  PutAccountSchema,
} from '../models';
import { GenericAccountId } from '../models/models.generic';

extendZodWithOpenApi(z);
const c = initContract();

export const apiAccounts = c.router({
  getAccounts: {
    method: 'GET',
    path: `/1.0/accounts`,
    description: 'Gets all accounts for the current user.',
    responses: {
      200: z.array(AccountSchema),
    },
    metadata: mcpExposeMetadata,
  },
  getAccountId: {
    method: 'GET',
    path: `/1.0/accounts/:accountId`,
    pathParams: z.object({ accountId: GenericAccountId }),
    description: 'Gets an account by `accountId`',
    responses: {
      200: AccountSchema,
    },
    metadata: mcpExposeMetadata,
  },
  createAccount: {
    method: 'POST',
    path: `/1.0/accounts`,
    description: 'Creates an account.',
    body: PostAccountSchema,
    responses: {
      200: AccountSchema,
    },
  },
  updateAccountId: {
    method: 'PUT',
    path: `/1.0/accounts/:accountId`,
    pathParams: z.object({ accountId: GenericAccountId }),
    description: 'Updates an account by `accountId`.',
    body: PutAccountSchema,
    responses: {
      200: OKGeneric,
    },
  },
  deleteAccountId: {
    method: 'DELETE',
    path: `/1.0/accounts/:accountId`,
    pathParams: z.object({ accountId: GenericAccountId }),
    description: 'Deletes an account by `accountId`. User must be an account owner.',
    body: null,
    responses: {
      200: OKGeneric,
    },
  },
});
